import { CheckMembershipStatus, ICheckMembershipStatusRequest, ICheckMembershipStatusResponse } from '../contracts';
import { CreateMembershipStatus } from '@lib/types';

export const CheckMembershipStatusStub: () => CheckMembershipStatus = () => {
  let checkCounter = 0;
  let outdata: string[] = [];
  let timer: NodeJS.Timer | null = null;

  const beginChecks: () => void = () => {
    outdata = [CreateMembershipStatus.INITIALIZED];
    timer = setInterval(() => {
      console.log('source timer');
      checkCounter = checkCounter + 1;
      if (checkCounter > 0) {
        outdata.push(CreateMembershipStatus.COMPLETED);
        if (timer != null) {
          // @ts-ignore
          clearInterval(timer);
        }
      }
    }, 5000);
  };

  return async (request: ICheckMembershipStatusRequest) => {
    const response: ICheckMembershipStatusResponse = {
      statusCode: 200,
      data: {
        process: 'create-membership',
        sessionId: request.sessionId,
        status: [CreateMembershipStatus.INITIALIZED],
      },
      statusDescription: 'Test status',
    };
    if (checkCounter === 0) {
      beginChecks();
    }
    response.data!.status = outdata;
    checkCounter = checkCounter + 1;
    if (response.data != null) {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject({ error: 'Invalid response' });
    }
  };
};
